import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('ep-split-layout')
export class EPSplitLayout extends LitElement {

  render() {
    return html`
      <div part="root">
        <aside part="sidebar">
          <slot name="sidebar"></slot>
        </aside>
        <main part="main">
          <slot name="main"></slot>
        </main>
      </div>
    `
  }

  static styles = css`
    :host {
      display: contents;
      --root-gap: 1.5rem;
      --sidebar-position-top: 1.5rem;
      --sidebar-position-left: 0;
      --sidebar-height: calc(100vh - 6rem);
      --root-template-areas: "sidebar main";
      --root-template-columns: 1fr 5fr;
    }

    [part=root] {
      display: grid;
      grid-template-areas: var(--root-template-areas);
      grid-template-columns: var(--root-template-columns);
      gap: var(--root-gap);
    }
    
    [part=sidebar] {
      grid-area: sidebar;
      position: sticky;
      top: var(--sidebar-position-top);
      left: var(--sidebar-position-left);
      display: block;
      height: var(--sidebar-height);
      overflow-y: auto;
    }

    [part=main] {
      grid-area: main;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-split-layout': EPSplitLayout
  }
}
